import React from 'react'

import { useSearchParams } from 'react-router-dom'
import GridController from '../components/GridController'
import { useLocalStorage } from '../hooks/useLocalStorage'
// import { config } from '../utilities/constants.js'
// import useAxios from '../hooks/useAxios.js'
import { products as dataArray } from '../data'
import appUtilities from '../utilities/appUtilities.js'

export default function BOM() {
    const [searchParams] = useSearchParams()
    const sessionObj = Object.fromEntries([...searchParams])
    const [isCAD, setIsCADCurrency] = useLocalStorage('isCAD', false)

    React.useEffect(() => {
        appUtilities.reportLogging()
        return () => appUtilities.clearLog()
    }, [])

    // React.useEffect(() => {
    //     data = dataArray[isCAD ? 1 : 0]
    //     console.log('BOM UE & isCAD', isCAD)
    // }, [isCAD])

    let data = [...dataArray[isCAD ? 1 : 0]]

    return (
        <GridController
            sessionObj={sessionObj}
            invList={data}
            isCAD={isCAD}
            setIsCADCurrency={setIsCADCurrency}
        />
    )
}
